const animateFigure = require('./animate-figure').default

export const animateItem = require('./animate-item').default
export const animateBlock = require('./animate-block').default
export const animateCard = require('./animate-card').default
export const animateAnim = require('./animate-anim').default

export const animateScrolling = animateFigure.animateScrolling
export const animateWaypoint = animateFigure.animateWaypoint
export const animateRepeat = animateFigure.animateRepeat
